// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"9905e7d8","787":"23deea3c"}[chunkId] + ".chunk.js";
};